import { InjectionToken } from '@angular/core';
import { RuntimeEnvironment } from '@lx/shared/types';

export const ENVIRONMENT = new InjectionToken<RuntimeEnvironment>('ENVIRONMENT');
